import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Paginated } from '@marketing-os/shared';
import { apiGet, apiPost } from '@/lib/api';
import { qk } from '@/lib/queryClient';
import type { Notification } from '@/types/api';

export function useNotifications(params: { page?: number; pageSize?: number; unreadOnly?: boolean } = {}) {
  return useQuery({
    queryKey: qk.notifications(params),
    queryFn: () => apiGet<Paginated<Notification>>('/notifications', { params }),
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: qk.notificationsUnread,
    queryFn: () => apiGet<{ count: number }>('/notifications/unread-count'),
    refetchInterval: 120_000,
  });
}

export function useMarkNotificationRead() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiPost(`/notifications/${id}/read`),
    onSuccess: () => void client.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useMarkAllNotificationsRead() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => apiPost('/notifications/read-all'),
    onSuccess: () => void client.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
